import React from 'react';

const PromptEdit = ({
  property,
  value = '',
  limit = 9000,
  onChange,
  placeholder = '',
  id,
  rows = 3,
}) => {
  const { length } = value || '';
  const handleChange = (e) => {
    const { value: next } = e.target;
    if (next.length <= limit) {
      onChange(next);
    } else {
      onChange(next.slice(0, limit));
    }
  };

  return (
    <div className="mb-3">
      <label className="form-label" htmlFor={id}>
        {property}
      </label>
      <textarea
        id={id}
        className="form-control"
        rows={rows}
        value={value || ''}
        onChange={handleChange}
        placeholder={placeholder}
        aria-describedby={id ? `${id}-counter` : undefined}
      />
      <small id={id ? `${id}-counter` : undefined} className="d-block text-muted mt-1">
        {length}
        {' / '}
        {limit}
      </small>
    </div>
  );
};

export default PromptEdit;
